import { Toast } from '../../../models/common.models';

export class DisplayToast {
  static type = '[UI] Toast';

  constructor(readonly toast: Partial<Toast>) {
    this.toast = {
      show: true,
      type: 'success',
      ...toast,
    };
  }
}
